// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.viral-clips-metadata {
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.viral-clips-metadata h2 {
  margin-top: 0;
  margin-bottom: 20px;
  color: #333;
}

.model-info {
  margin-bottom: 30px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #3498db;
}

.model-info h3 {
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 1.1rem;
  color: #333;
}

.model-details {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 15px;
}

.model-detail {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.model-detail .label {
  font-size: 0.8rem;
  color: #666;
  font-weight: 600;
  text-transform: uppercase;
}

.model-detail .value {
  font-size: 0.95rem;
  color: #333;
  padding: 5px 10px;
  background-color: #eef2f5;
  border-radius: 4px;
  font-family: monospace;
}

.clips-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.clip-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  border: 1px solid #eee;
}

.clip-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.clip-card.expanded {
  grid-column: 1 / -1;
  transform: none;
}

.clip-header {
  padding: 15px;
  background-color: #f8f8f8;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.clip-header h3 {
  margin: 0;
  font-size: 1.1rem;
  color: #333;
  flex: 1 1;
}

.viral-score {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 10px;
}

.score-label {
  font-size: 0.7rem;
  color: #777;
  margin-bottom: 3px;
}

.score-value {
  font-weight: bold;
  font-size: 1rem;
  color: #fff;
  background-color: #3498db;
  padding: 3px 8px;
  border-radius: 12px;
}

.clip-caption {
  padding: 12px 15px;
  font-size: 0.9rem;
  color: #555;
  background-color: #f0f7ff;
  border-bottom: 1px solid #e0e0e0;
  font-style: italic;
}

.clip-metadata {
  padding: 15px;
}

.metadata-section {
  margin-bottom: 15px;
}

.metadata-section h4 {
  margin-top: 0;
  margin-bottom: 8px;
  font-size: 0.9rem;
  color: #555;
}

.factors-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.factor-item {
  background-color: #f0f7ff;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 0.85rem;
  color: #3498db;
  border: 1px solid #d6eaff;
}

.hashtags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.hashtag {
  background-color: #e8f5e9;
  color: #2e7d32;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 0.85rem;
  border: 1px solid #c8e6c9;
}

.expanded-content {
  padding: 15px;
  background-color: #f9f9f9;
  border-top: 1px solid #eee;
}

.suggestions-list,
.prompts-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.suggestion-item,
.prompt-item {
  padding: 8px 12px;
  margin-bottom: 5px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  font-size: 0.9rem;
  color: #333;
}

.suggestion-item {
  border-left: 3px solid #f39c12;
}

.prompt-item {
  border-left: 3px solid #9c27b0;
}

.clip-timing {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-top: 15px;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.time-item {
  display: flex;
  align-items: center;
  gap: 5px;
}

.time-label {
  font-weight: 600;
  font-size: 0.8rem;
  color: #555;
}

.time-value {
  font-family: monospace;
  background-color: #e0e0e0;
  padding: 3px 6px;
  border-radius: 3px;
  font-size: 0.85rem;
}

.time-value-seconds {
  font-size: 0.8rem;
  color: #777;
  font-family: monospace;
}

.no-clips-message {
  grid-column: 1 / -1;
  padding: 30px;
  text-align: center;
  background-color: #f9f9f9;
  border-radius: 8px;
  color: #777;
  font-style: italic;
}

@media (max-width: 768px) {
  .clips-container {
    grid-template-columns: 1fr;
  }
  
  .model-details {
    grid-template-columns: 1fr;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/css/ViralClipsMetadata.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;EAEE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".viral-clips-metadata {\n  padding: 20px;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.viral-clips-metadata h2 {\n  margin-top: 0;\n  margin-bottom: 20px;\n  color: #333;\n}\n\n.model-info {\n  margin-bottom: 30px;\n  padding: 15px;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  border-left: 4px solid #3498db;\n}\n\n.model-info h3 {\n  margin-top: 0;\n  margin-bottom: 15px;\n  font-size: 1.1rem;\n  color: #333;\n}\n\n.model-details {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 15px;\n}\n\n.model-detail {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.model-detail .label {\n  font-size: 0.8rem;\n  color: #666;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.model-detail .value {\n  font-size: 0.95rem;\n  color: #333;\n  padding: 5px 10px;\n  background-color: #eef2f5;\n  border-radius: 4px;\n  font-family: monospace;\n}\n\n.clips-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 20px;\n}\n\n.clip-card {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  position: relative;\n  border: 1px solid #eee;\n}\n\n.clip-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n}\n\n.clip-card.expanded {\n  grid-column: 1 / -1;\n  transform: none;\n}\n\n.clip-header {\n  padding: 15px;\n  background-color: #f8f8f8;\n  border-bottom: 1px solid #eee;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.clip-header h3 {\n  margin: 0;\n  font-size: 1.1rem;\n  color: #333;\n  flex: 1;\n}\n\n.viral-score {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-left: 10px;\n}\n\n.score-label {\n  font-size: 0.7rem;\n  color: #777;\n  margin-bottom: 3px;\n}\n\n.score-value {\n  font-weight: bold;\n  font-size: 1rem;\n  color: #fff;\n  background-color: #3498db;\n  padding: 3px 8px;\n  border-radius: 12px;\n}\n\n.clip-caption {\n  padding: 12px 15px;\n  font-size: 0.9rem;\n  color: #555;\n  background-color: #f0f7ff;\n  border-bottom: 1px solid #e0e0e0;\n  font-style: italic;\n}\n\n.clip-metadata {\n  padding: 15px;\n}\n\n.metadata-section {\n  margin-bottom: 15px;\n}\n\n.metadata-section h4 {\n  margin-top: 0;\n  margin-bottom: 8px;\n  font-size: 0.9rem;\n  color: #555;\n}\n\n.factors-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n\n.factor-item {\n  background-color: #f0f7ff;\n  padding: 5px 10px;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  color: #3498db;\n  border: 1px solid #d6eaff;\n}\n\n.hashtags-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n\n.hashtag {\n  background-color: #e8f5e9;\n  color: #2e7d32;\n  padding: 5px 10px;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  border: 1px solid #c8e6c9;\n}\n\n.expanded-content {\n  padding: 15px;\n  background-color: #f9f9f9;\n  border-top: 1px solid #eee;\n}\n\n.suggestions-list,\n.prompts-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.suggestion-item,\n.prompt-item {\n  padding: 8px 12px;\n  margin-bottom: 5px;\n  background-color: #fff;\n  border-radius: 4px;\n  border: 1px solid #e0e0e0;\n  font-size: 0.9rem;\n  color: #333;\n}\n\n.suggestion-item {\n  border-left: 3px solid #f39c12;\n}\n\n.prompt-item {\n  border-left: 3px solid #9c27b0;\n}\n\n.clip-timing {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n  margin-top: 15px;\n  padding: 10px;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n}\n\n.time-item {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.time-label {\n  font-weight: 600;\n  font-size: 0.8rem;\n  color: #555;\n}\n\n.time-value {\n  font-family: monospace;\n  background-color: #e0e0e0;\n  padding: 3px 6px;\n  border-radius: 3px;\n  font-size: 0.85rem;\n}\n\n.time-value-seconds {\n  font-size: 0.8rem;\n  color: #777;\n  font-family: monospace;\n}\n\n.no-clips-message {\n  grid-column: 1 / -1;\n  padding: 30px;\n  text-align: center;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  color: #777;\n  font-style: italic;\n}\n\n@media (max-width: 768px) {\n  .clips-container {\n    grid-template-columns: 1fr;\n  }\n  \n  .model-details {\n    grid-template-columns: 1fr;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
